export default __webpack_public_path__ + "static/media/14t.b8459e9b.jpg";